<template>
  <h1 class="white-color">
      This page is under construction!
  </h1>
</template>

<script>
export default {

}
</script>

<style>

</style>